import React, { memo } from 'react';

import Tooltip from '@mui/material/Tooltip';
import { FiAlertCircle } from '@react-icons/all-files/fi/FiAlertCircle';

import { IUiTooltipProps } from './ui-tooltip.model';

export const UiTooltip = memo<IUiTooltipProps>(
  ({ text, size = 18, margin = 10, color, style }) => {
    return (
      <Tooltip
        title={text}
        data-testid="tooltip"
        placement="right-end"
        enterTouchDelay={100}
        leaveTouchDelay={15000}
      >
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <FiAlertCircle
            style={{ marginLeft: margin, marginRight: margin, ...style }}
            size={size}
            color={color || '#0f132a'}
          />
        </span>
      </Tooltip>
    );
  }
);
